(function () {
  var THRESHOLD = 100;

  /* ------------------------------------------------------------------
     HERO PARALLAX
     The photograph lags the page as it scrolls. Scroll-driven, so it is
     motionless whenever the page is — not the autonomous breathing
     animation that was removed earlier.

     Depth comes from the section's own setting via data-fs-parallax, so
     Matt can dial it in the theme editor without touching code.
     ------------------------------------------------------------------ */
  var hero = null;
  var layer = null;
  var depth = 0;
  var heroTop = 0;
  var heroHeight = 0;
  var lastOffset = null;

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Phones are excluded on purpose: the address bar hiding mid-scroll
     changes the viewport height, which makes a height-derived parallax
     jitter, and the portrait crop has less room to give. */
  var mqSmall = window.matchMedia('(max-width: 749px)');

  function measureHero() {
    hero = document.querySelector('.fs-hero');
    layer = hero ? hero.querySelector('.fs-hero__image') : null;
    depth = hero ? parseFloat(hero.getAttribute('data-fs-parallax')) : 0;
    if (!depth || depth < 0) depth = 0;
    if (hero) {
      heroTop = hero.getBoundingClientRect().top + window.scrollY;
      heroHeight = hero.offsetHeight;
    }
    lastOffset = null;
  }

  function parallaxOn() {
    return !!layer && depth > 0 && !mqReduce.matches && !mqSmall.matches;
  }

  function parallax() {
    if (!parallaxOn()) {
      if (layer && layer.style.transform) {
        layer.style.transform = '';
        lastOffset = null;
      }
      return;
    }
    /* Clamped at the foot of the hero — past it there is nothing on screen
       to move, so stop writing transforms entirely. */
    var travelled = window.scrollY - heroTop;
    if (travelled < 0) travelled = 0;
    if (travelled > heroHeight) travelled = heroHeight;

    var offset = Math.round(travelled * depth * 100) / 100;
    if (offset === lastOffset) return;
    lastOffset = offset;
    layer.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
  }

  /* Two separate states, on purpose:

     .fs-header-scrolled  — the bone bar arrives, 100px in. Cosmetic.
     .fs-hero-gone        — the hero has left the screen entirely. This is
                            what reveals the wordmark lockup, so the header
                            never repeats a name the hero is still showing
                            in display type two inches below it.

     "Gone" means no hero pixel is visible BELOW the bar: the bar is opaque
     by then, so the strip behind it does not count. */
  function heroIsGone(hero) {
    var bar = document.querySelector('.header-wrapper');
    var barH = bar ? bar.offsetHeight : 0;
    return hero.getBoundingClientRect().bottom <= barH;
  }

  function update() {
    var heroEl = document.querySelector('.fs-hero');
    if (!heroEl) {
      document.body.classList.add('fs-header-no-hero');
      document.body.classList.remove('fs-header-scrolled');
      document.body.classList.remove('fs-hero-gone');
      return;
    }
    document.body.classList.remove('fs-header-no-hero');
    if (window.scrollY > THRESHOLD) {
      document.body.classList.add('fs-header-scrolled');
    } else {
      document.body.classList.remove('fs-header-scrolled');
    }
    if (heroIsGone(heroEl)) {
      document.body.classList.add('fs-hero-gone');
    } else {
      document.body.classList.remove('fs-hero-gone');
    }
  }
  // Aggressive - remove class on load
  document.body.classList.remove('fs-header-scrolled');
  document.body.classList.remove('fs-hero-gone');
  var ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function () { update(); parallax(); ticking = false; });
      ticking = true;
    }
  }
  function onResize() {
    measureHero();
    update();
    parallax();
  }

  function init() {
    measureHero();
    update();
    parallax();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    /* Re-measure when the preference changes rather than on every frame */
    if (mqReduce.addEventListener) {
      mqReduce.addEventListener('change', onResize);
      mqSmall.addEventListener('change', onResize);
    }
    /* The theme editor re-renders the section in place */
    document.addEventListener('shopify:section:load', onResize);
    // Keep enforcing every 100ms - Dawn re-adds class
    setInterval(update, 100);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
